import { routerApp, baseUrl, enableOnPremise } from '../app.module';
import angular from 'angular';
import { httpRequestGenerator } from './utilities';

routerApp.factory('ManagementVesselsService', ['$http', '$log', function($http: angular.IHttpService, $log: angular.ILogService) {
    var requestFunc = httpRequestGenerator(enableOnPremise, $http);
    return {
        getVessels: (clientId: string = null) => {
            return requestFunc({
                url: `${baseUrl}v1/management/vessel/` + (clientId ? `?client_id=${clientId}` : ''),
                method: 'GET'
            });
        },
        getVessel: (vesselId: string) => {
            return requestFunc({
                url: `${baseUrl}v1/management/vessel/${vesselId}`,
                method: 'GET'
            });
        },
        createVessel: (vessel: any) => {
            return requestFunc({
                url: `${baseUrl}v1/management/vessel/create`,
                method: 'POST',
                data: vessel
            });
        },
        updateVessel: (vesselId: string, user: any) => {
            return requestFunc({
                url: `${baseUrl}v1/management/vessel/update/${vesselId}`,
                method: 'PUT',
                data: user
            });
        },
        disableVessel: (vesselId: string, user: any) => {
            return requestFunc({
                url: `${baseUrl}v1/management/vessel/disable/${vesselId}`,
                method: 'PUT',
                data: user
            });
        },
        retrieveNavtorID: (vesselId: string, vessel: any) => {
            return requestFunc({
                url: `${baseUrl}v1/management/vessel/retrieveNavtorID/${vesselId}`,
                method: 'PUT',
                data: vessel
            });
        },
        updateEngineModel: (vesselId: string, data: any, data_type: any) => {
            if (data_type == 'file') {
                var form = new FormData();
                form.append('filedata', data, data.name);
                return requestFunc({
                    url: `${baseUrl}v1/management/vessel/updateEngineModel/${vesselId}`,
                    method: 'POST',
                    data: form,
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                })
            }
            else if (data_type == 'dict') {
                return requestFunc({
                    url: `${baseUrl}v1/management/vessel/updateEngineModel/${vesselId}`,
                    method: 'POST',
                    data: data
                });
            }
        }
    }
}]);